module.exports = __webpack_public_path__ + "img/early-bird.5b635e1d.jpg";